import type { CurrencyCode } from '@99designs/i18n';
import type { ProductGroupPrice } from '../types';

type Currency = {
    currency: CurrencyCode;
};

export const getStartingPriceForProduct = (
    productGroupPrices: ProductGroupPrice[],
    key: string,
    siteCurrency: CurrencyCode
) => {
    if (!productGroupPrices) {
        return;
    }
    const currentProductPrice = productGroupPrices.filter(
        (productGroupPrice) => productGroupPrice.key === key
    );

    if (!currentProductPrice || currentProductPrice.length === 0) {
        return;
    }
    const startingPriceInUsersCurrency = currentProductPrice[0].prices.find(
        ({ currency }: Currency) => currency === siteCurrency
    );
    const startingPriceInUSD = currentProductPrice[0].prices.find(
        ({ currency }: Currency) => currency === 'USD'
    );
    return startingPriceInUsersCurrency || startingPriceInUSD;
};
